import { isWeb } from './platform';
import { sorceryImageUrl } from './cardImageUrl';

// Local API runs on the same origin as the renderer. Relative URLs only.
// The renderer server's port changes per launch but that's fine because
// all fetches use root-relative paths that resolve against the current origin.

export function getLocalApiOrigin() {
  return '';
}

export const LOCAL_API_ORIGIN = '';

/**
 * Resolve a card image URL to a root-relative path.
 *
 * Card instances shared by remote players in multiplayer sessions may carry
 * absolute URLs with the other player's local port. Strip a localhost
 * `http(s)://host:port` prefix so the image loads from the current origin.
 * Non-localhost absolute URLs (e.g. the CDN a web client uses) stay intact.
 *
 * On web the reverse applies: a desktop peer shares `/sorcery-images/<slug>`
 * paths that only its own Electron server can serve, so remap them to the CDN.
 */
export function resolveLocalImageUrl(url) {
  if (!url) return '';
  const stripped = url.replace(/^https?:\/\/(?:localhost|127\.0\.0\.1)(?::\d+)?/i, '');
  if (isWeb()) {
    const m = stripped.match(/^\/sorcery-images\/([a-z0-9_.-]+)\.webp(\?.*)?$/i);
    if (m) return sorceryImageUrl(m[1]) + (m[2] || '');
  }
  return stripped;
}
